<template>
  <div class="dashboard">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_icone header_element">
          <!--          <span class="icon icon-left-arrow icon-lg"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

        </router-link>
        <h1 class="header_element">Dashboard</h1>
      </div>
    </div>
    <!--    <div class="content_container" v-if="!getDeviceType(['desktop','tablet'])">-->
    <!--      <div class="content_section" v-for="(mask,index) in masksList">-->
    <!--        <div class="content-animal" :class="{'own': checkMask(mask.id)}">-->
    <!--          <img :src="mask.icon" alt="">{{ mask.name }}-->
    <!--        </div>-->
    <!--        <div class="content-texture" :class="{'own':checkTexture(mask.id, texture.id) }"-->
    <!--             v-for="(texture, index) in mask.textures ">-->
    <!--          <img :src="texture.icon" alt="">-->
    <!--          {{ texture.name }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="content_container ">
      <div class="desktop">
        <div class="event-list ">
          <label>Vos événements :</label>
          <button class="event btn-primary-dark content_element" :class="{'current':section.id===event.id}"
                  :data-section=key @click="showSection" v-for="(event,key) in user.order">{{ event.event_name }}
          </button>
        </div>
        <div class="event-tabs ">
          <div class="tab content_element btn-primary-dark Products " :class="{'current':subsection==='Products'}"
               data-section="Products" @click="showSubSection">
            <p class="content_element_link" data-section="Products">Produits</p>
          </div>
          <div class="tab content_element btn-primary-dark Pictures " :class="{'current':subsection==='Pictures'}"
               data-section="Pictures" @click="showSubSection">
            <p class="content_element_link" data-section="Pictures">Photos</p>
          </div>
          <div class="tab content_element btn-primary-dark Ranking " :class="{'current':subsection==='Ranking'}"
               data-section="Ranking" @click="showSubSection">
            <p class="content_element_link" data-section="Ranking">Classement</p>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div class="event-list ">
          <select name="" id="section" v-model="section">
            <option class="event btn-primary-dark content_element" :class="{'current':section.id===event.id}"
                    :data-section=key @click="showSection" :value="event" v-for="(event,key) in user.order">
              {{ event.event_name }}
            </option>
          </select>
        </div>
        <div class="event-tabs ">
          <select name="" id="subsection" v-model="subsection">
            <option class="tab content_element btn-primary-dark Products " :class="{'current':subsection==='Products'}"
                    value="Products">Produits
            </option>
            <option class="tab content_element btn-primary-dark Pictures " :class="{'current':subsection==='Pictures'}"
                    value="Pictures">Photos
            </option>
            <option class="tab content_element btn-primary-dark Ranking " :class="{'current':subsection==='Ranking'}"
                    value="Ranking">Classement
            </option>
          </select>
        </div>
      </div>

      <div class="tab-container">
        <component :is="'Event'+subsection" :order="section" :key="section.id"
                   @updateFunction="updateFunction"></component>
      </div>
    </div>

  </div>
</template>
<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";
import PopUp from "../components/Modals/Modal";
import EventProducts from "../components/Events/Widgets/EventProducts";
import EventPictures from "../components/Events/Widgets/EventPictures";
import EventRanking from "../components/Events/Widgets/EventRanking";

export default {
  name: 'Dashboard',
  data() {
    return {
      section: this.$store.state.user.order[0],
      subsection: 'Products',
      selectedPictures: []

    }
  },
  components: {
    PopUp,
    EventProducts,
    EventPictures,
    EventRanking
  },
  methods: {
    ...mapActions([
      'getOrderProducts',
      'getOrderPictures',
      'gerOrderRank'
    ]),
    updateFunction(e) {
      let data = {
        'subsection': this.subsection,
        'selectedPictures': e
      }
      this.$emit('updateFunction', data)
    },
    showSection(e) {
      this.section = this.user.order[e.target.dataset.section]
      this.selectedPictures = []


    },
    showSubSection(e) {
      this.subsection = e.target.dataset.section
      let data = {
        'subsection': this.subsection,
        'selectedPictures': this.selectedPictures
      }
      this.$emit('updateFunction', data)
    },


  },
  computed: {
    ...mapState([
      "user"
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});
    this.$emit('updateFunction', this.subsection)

  }
}
</script>
<style scoped>

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}


.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_container {
  padding: 0 20px;

}


.content_section {
  margin: 20px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #297F9E;
}


.event-list, .event-tabs {
  display: flex;
  align-items: center;
}

.event-list > *, .event-tabs > * {
  margin: 10px;
}

.tab:hover {
  cursor: pointer;
}

.event-list p, .event-tabs p {
  margin: 0;
}

.content_element.current {
  color: #FFF;
  border: 2px solid #297F9E;
  background: #297F9E;
}


/*     DESKTOP EXCEPTION       */
@media screen and (min-width: 750px) {
  .mobile {
    display: none;
  }

  .desktop {
    display: block;
  }

  .content_container .desktop {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /*position: relative;*/
  }
}


/*     MOBILE EXCEPTION       */
@media screen and (max-width: 750px) {

  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .content_container .mobile {
    display: flex;
    /*position: relative;*/
  }

  .mobile select {
    padding: 5px;
    margin: 10px;
  }
}


</style>
